define.alias("shared/components/shared/post-tagging/tag-dropdown-item", "calendar/components/shared/post-tagging/tag-dropdown-item");